export default {
  viewerPercentages: {},
};
